function Defer () {
  let count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return {
    data() {
      return {
        displayPriority: 0
      };
    },
    mounted() {
      this.runDisplayPriority();
    },
    methods: {
      runDisplayPriority() {
        const step = () => {
          requestAnimationFrame(() => {
            this.displayPriority++;
            if (this.displayPriority < count) {
              step();
            }
          });
        };
        step();
      },
      defer(priority) {
        return this.displayPriority >= priority;
      }
    }
  };
}

export { Defer as default };
//# sourceMappingURL=defer.js.map
